package com.timacookies

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.window

enum class Language(
  val code: String,
) {
  EN("en"),
  DE("de"),
}

@Composable
fun currentLanguage(): Language {
  val ctx = rememberPageContext()

  return remember(ctx.route.path) {
    val pathLang =
      ctx.route.path
        .split("/")
        .filter { it.isNotEmpty() }
        .getOrNull(0)

    pathLang?.lowercase()?.let { lang ->
      Language.entries.find { it.code == lang }
    } ?: run {
      val browserLang = window.navigator.language
        .take(2)
        .lowercase()

      Language.entries.find { it.code == browserLang }
    } ?: Language.EN
  }
}
